import { CtModelRouteData, CtModelType } from "@ctsolution/ct-framework";

export const SchedulerRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("scheduler")
  .setModelType(CtModelType.CALENDAR);
